import React from 'react';
import { Link } from "react-router-dom";
import { Button, Container } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "./general.css";

const Page404 = () => {
    return (
        <>
            <div className='m-3'>
                <h1 className='mt-5'>ページが存在しないよ</h1>
                <Link to="/">
                    <Button className='mt-5' variant='light'>トップページにもどる</Button>
                </Link>
            </div>
        </>
    )
}

export default Page404;
